//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { channelTypes } from '@motionelements/core/src/helpers/channelTypes';

export default {
  name: 'channel',
  layout: 'empty',
  components: {
    ChannelPage: () => import('@/components/channels/ChannelPage.vue'),
    ProductPage: () => import('@/components/ProductPage.vue'),
  },
  async asyncData({ params, store }) {
    const channel = channelTypes.find(({ link }) => link.includes(params.channel));
    if (channel) {
      const channelId = channel.id;
      store.dispatch('channels/setChannelType', channelId);
      return { channelId };
    }
  },
  data() {
    return {
      channelId: null,
    };
  },
  computed: {
    ...mapState({
      productId: state => state.product.id,
    }),
  },
  methods: {
    handleSeoRedirect(targetUrl, route) {
      if (!targetUrl) { // just in case
        return;
      }
      const url = new URL(targetUrl);
      if (url.pathname !== route.path) {
        // replace path, keep search query
        const redirectFullPath = route.fullPath.replace(route.path, url.pathname);
        this.$nuxt.context.redirect(301, redirectFullPath);
      }
    },
  },
  async fetch({ store, error }) {
    const productId = store.state.product.id;
    if (productId) {
      try {
        await store.dispatch('product/fetchProductSchema');
      } catch (err) {
        console.error(err);
      }
      try {
        await store.dispatch('product/fetchProduct', { id: productId }); // public info to render the product page fast
        // this.handleSeoRedirect(store.state.product.current?.url, this.$nuxt.$route);
      } catch (err) {
        console.error(err);
        error({ statusCode: _.get(err, 'response.status') || 500 });
      }
    }
  },
};
